import React from 'react'
import { SystemWrap } from './ExChangeSetting/styles'
import TableAPI from '../../components/TableAPI'
import { humanevent_columns } from './HumanEventColumns'

const HumanEvent = () => {
	const [type, setType] = React.useState('GH')

	return (
		<SystemWrap>
			<TableAPI
				title={'휴면이벤트'}
				columns={humanevent_columns}
				usermodal={false}
				height={'default'}
				apikey={`/admin/settings?type=${type}&`}
				pagination={false}
			/>
		</SystemWrap>
	)
}

export default React.memo(HumanEvent)
